import { FC, useState } from 'react';
import {
  Tooltip,
  Divider,
  Box,
  Card,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Typography,
  useTheme,
  Modal,
  Button
} from '@mui/material';

import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import { useGetUsers } from '../hook/useGetUserList';
import useDelete from 'src/hooks/useDelete';
import { toast } from 'react-toastify';
import useHooks from 'src/hooks/useHooks';

const modalStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  bgcolor: 'background.paper',
  borderRadius: '16px',
  boxShadow: 24,
  p: 4
};

const UserTable = ({ data, refetch }: { data: any; refetch: () => {} }) => {
  const [open, setOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const { mutateAsync: deleteUser } = useDelete();
  const theme = useTheme();
  const {get}=useHooks()

  const handleOpen = (userId: number) => {
    setSelectedUserId(userId);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedUserId(null);
  };

  const handleDelete = () => {
    if (selectedUserId !== null) {
      toast.promise(
        deleteUser({
          url: `/delete/webuser/${selectedUserId}`
        }),
        {
          pending: "O'chirilmoqda...",
          success: {
            render() {
              handleClose();
              refetch();
              return "Foydalanuvchi muvoffaqiyatli o'chrildi!";
            }
          },
          error: {
            render({ data }) {
              return `Error: ${JSON.stringify(get(data, 'response.data'))}`;
            }
          }
        }
      );
    }
  };

  return (
    <Card>
      <Divider />
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell align="center">Foydalanuvchi nomi</TableCell>
              <TableCell align="center">Foydalanuvchi turi</TableCell>
              <TableCell align="right">Harakatlar</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((user) => (
              <TableRow hover key={user.id}>
                <TableCell>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                    noWrap
                  >
                    {user.id}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                    noWrap
                  >
                    {user.username}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                    noWrap
                  >
                    {user.is_superuser ? 'Admin' : 'User'}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Tooltip title="O'chirish" arrow>
                    <IconButton
                      sx={{
                        marginRight: '15px',
                        '&:hover': { background: theme.palette.error.light },
                        color: theme.palette.error.main
                      }}
                      color="inherit"
                      size="small"
                      onClick={() => handleOpen(user.id)}
                    >
                      <DeleteTwoToneIcon sx={{ fontSize: 25 }} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            O'chirishga ishonchingiz komilmi?
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '20px',
              mt: 3
            }}
          >
            <Button
              variant="contained"
              onClick={handleClose}
              sx={{ fontSize: '16px' }}
            >
              Bekor qilish
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleDelete}
              sx={{ fontSize: '16px' }}
            >
              Ok
            </Button>
          </Box>
        </Box>
      </Modal>
    </Card>
  );
};

export default UserTable;
